import React from 'react';
import ReactDOM from 'react-dom';
import serialize from 'form-serialize';
import PropTypes from 'prop-types';
import FormSaveButtons from './FormSaveButtons';
import FieldGroup from './FieldGroup';
import BootstrapForm from 'react-bootstrap/lib/Form';
import Form from './Form';
import AlertMessage from '../AlertMessage';
import { AlertMessageTypes } from '../../constants/index';
import CancelConfirmModal from "../CancelConfirmModal";

export default class NestedForms extends Form {
  static propTypes = {
    addAction: PropTypes.func,
    branded: PropTypes.bool,
    buttonGroupClass: PropTypes.string,
    buttonStyle: PropTypes.string,
    cancelButton: PropTypes.bool,
    children: PropTypes.any,
    data: PropTypes.array.isRequired,
    errorMessage: PropTypes.string,
    errorMessages: PropTypes.array,
    fieldGroupClass: PropTypes.string,
    isCreate: PropTypes.bool,
    onCancel: PropTypes.func,
    saveButton: PropTypes.bool,
    saveButtonText: PropTypes.string,
    updateAction: PropTypes.func
  };

  static defaultProps = {
    branded: false,
    saveButton: true,
    cancelButton: true,
    isCreate: true
  };

  constructor(props) {
    super(props);
    this.saveAndClose = this.saveAndClose.bind(this);
    this.renderChildren = this.renderChildren.bind(this);
    this.state = { errorMessages: props.errorMessages, isDisabled: false };
  }

  save = async (addAnother) => {
    let form = ReactDOM.findDOMNode(this.bootstrapForm);
    if (form.checkValidity()) {
      let obj = serialize(form, { hash: true, empty: true });
      this.props.data.forEach((dataObject, index) => {
        Object.assign(dataObject, obj[index]);
      });
      if (!this.props.isCreate) {
        this.props.updateAction(this.props.data);
      } else {
        this.props.addAction(this.props.data, addAnother);
      }
      return true;
    } else {
      this.setState({ errorMessage: 'Errors on the form!', runValidation: true, isDisabled: false });
      return false;
    }
  }

  renderChildren(obj, index) {
    if (this.props.children && obj) {
      let child = React.Children.only(this.props.children);
      return React.cloneElement(child, {
        id: obj.id,
        index: index,
        componentName: obj.component,
        errorMessage: this.props.errorMessages ? this.props.errorMessages.find((errorMsg) => { return errorMsg.id === obj.id }) : null
      });
    }
  }

  saveAndClose(e) {
    e.preventDefault();
    this.setState({ isDisabled: true });
    this.save();
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.saveAndClose(e);
    }
  }

  render() {
    const saveAndClose = this.props.saveButton ? this.saveAndClose : null;
    const cancel = this.props.cancelButton ? this.onCancel : null;
    return (
      <BootstrapForm ref={(form) => (this.bootstrapForm = form)}>
        {this.props.errorMessage &&
          <AlertMessage message={this.props.errorMessage} messageType={AlertMessageTypes.danger} visible={true} />}
        {this.props.data.map((obj, index) => {
          return (
            <FieldGroup
              className={this.props.fieldGroupClass}
              data={obj}
              key={obj.id}
              onKeyDown={this.onKeyDown}
              runValidation={this.state.runValidation}
              scrollContainerId={this.props.scrollContainerId}
            >
              {this.renderChildren(obj, index)}
            </FieldGroup>
          )
        })}
        {(saveAndClose || cancel) && (
          <FormSaveButtons
            branded={this.props.branded}
            buttonStyle={this.props.buttonStyle}
            cancel={cancel}
            className={this.props.buttonGroupClass}
            isDisabled={this.state.isDisabled}
            save={saveAndClose}
            saveButtonText={this.props.saveButtonText}
          />
        )}
        <CancelConfirmModal branded={this.props.branded} show={this.state.showCancelConfirm} onCancelClose={this.onCancelClose} />
      </BootstrapForm>
    );
  }
}
